import get from "lodash/get"
import find from "lodash/find"
import isEmpty from "lodash/isEmpty"
import { createRef, Component } from "react"
import PropTypes from "prop-types"
import withRouter from "hoc-lib/router"
import { ReactSVG } from "react-svg"
import getContentUrl from "utils-lib/getContentUrl"
import { withLocalization } from "hoc-lib/localization"
import Typography from "component-lib/Base/components/Typography"
import { validateHashTagUrl } from "utils-lib/validation/validateHashTagUrl"
import { getWindow } from "utils-lib/getWindow"
import { FormattedTextField, ButtonPrimary } from "../../Base"
import "./BreadcrumbHeader.scss"

const ssrWindow = getWindow()

export const strings = {
  en_CA: {
    DELIVER: `Deliver to`,
  },
  fr_CA: {
    DELIVER: `Livrer à`,
  },
}

class BreadcrumbHeader extends Component {
  constructor(props) {
    super(props)
    this.breadcrumRef = createRef()
    this.state = {
      style: {},
    }
  }

  componentDidMount() {
    this.props.setModalId(``)
    const element = this.breadcrumRef.current
    if (element) {
      const { top } = element.getBoundingClientRect()
      if (top <= 32) {
        this.setState({ style: { marginTop: "4rem" } })
      }
    }
  }

  renderL1() {
    const {
      l1backgroundImage,
      title,
      forceGrayBGForComponent,
      showBreadcrumb,
    } = this.props

    const bodyWidth = ssrWindow.document.body.offsetWidth

    if (bodyWidth >= 768) {
      return (
        <div
          style={{
            background: !forceGrayBGForComponent
              ? `#fff` /* not sure why this was hard-coded, leaving as a fallback for backwards compatibility */
              : ``,
          }}
        >
          <div
            style={{
              background: !forceGrayBGForComponent
                ? `#fF4F4F4` /* not sure why this was hard-coded, leaving as a fallback for backwards compatibility */
                : ``,
            }}
          >
            <div
              className={`BreadcrumbHeader__heading maax-font-weight-black ${
                !showBreadcrumb ? `small-top-margin` : `large-top-margin`
              }`}
              style={{
                backgroundImage: `url(${getContentUrl(l1backgroundImage)})`,
                backgroundPosition: `50% 50%`,
                backgroundSize: `cover`,
                height: 300,
                margin: `0 auto`,
                maxWidth: 1200,
                overflow: `hidden`,
              }}
            >
              <div className="BreadcrumbHeader__heading--l1">
                <FormattedTextField
                  component="h1"
                  className="BreadcrumbHeader__heading-title mb-0 wm-text-new-green"
                  useTypography
                >
                  {title}
                </FormattedTextField>
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div
        style={{
          background: !forceGrayBGForComponent
            ? `#fff` /* not sure why this was hard-coded, leaving as a fallback for backwards compatibility */
            : ``,
        }}
      >
        <div
          className={`BreadcrumbHeader__heading maax-font-weight-black ${
            !showBreadcrumb ? `small-top-margin` : `large-top-margin`
          } mt-0`}
          style={{
            backgroundImage: `url(${getContentUrl(l1backgroundImage)})`,
            backgroundPosition: `50% 50%`,
            backgroundSize: `cover`,
            height: 300,
          }}
        />
        <FormattedTextField
          component="h1"
          className={`BreadcrumbHeader__heading maax-font-weight-black ${
            !showBreadcrumb ? `small-top-margin` : `large-top-margin`
          } container wm-text-new-green mb-3 mt-3`}
          setRef={this.breadcrumRef}
          style={this.state.style}
          useTypography
        >
          {title}
        </FormattedTextField>
      </div>
    )
  }

  handleNavigation(url, flag) {
    if (flag || validateHashTagUrl(url)) {
      ssrWindow.location = url
    } else {
      this.props.router.push(url)
    }
  }

  render() {
    const {
      analytics_key,
      headerLevel,
      languageRoute,
      l2image,
      l2imageAltText,
      title,
      l2description,
      l2ctaText,
      l2ctaUrl,
      l2secondaryDescription,
      l2SecondaryButton,
      l3description,
      l3ctaText,
      l3ctaUrl,
      l3secondaryDescription,
      l3SecondaryButton,
      isExternalLink,
      showBreadcrumb,
      level4Items,
      customerSelections,
      setCustomerAddress,
      onlineProducts,
      setModalId,
      strings,
    } = this.props

    const ssrWindow = getWindow()

    const isRoDumpsterPage =
      ssrWindow.location.href.includes("/dumpster-rental")

    let descriptionContent
    let secondaryDescriptionContent
    let ctaTextContent
    let ctaUrlContent

    let finalAddress = get(
      customerSelections,
      `customerSearchedAddress.label`,
      ``,
    )
    if (finalAddress === ``) {
      finalAddress = null
    } else {
      finalAddress = finalAddress.length === 1 ? null : finalAddress
    }

    if (headerLevel === `level1`) {
      return this.renderL1()
    }

    let secondaryCTA = {}
    if (headerLevel === `level3`) {
      descriptionContent = l3description
      secondaryDescriptionContent = l3secondaryDescription
      ctaTextContent = l3ctaText
      ctaUrlContent = l3ctaUrl
      secondaryCTA = { ...l3SecondaryButton }
    } else {
      descriptionContent = l2description
      secondaryDescriptionContent = l2secondaryDescription
      ctaTextContent = l2ctaText
      ctaUrlContent = l2ctaUrl
      secondaryCTA = { ...l2SecondaryButton }
    }

    const isCtaLinkExits = !!ctaUrlContent

    let l3path
    let homeRedirctionUrl
    if (headerLevel === `level4` && level4Items) {
      const l3Item = find(level4Items, (item) => item.level === `level3`)
      l3path = l3Item ? l3Item.href : `${languageRoute}`
      homeRedirctionUrl = l3path
    }

    return title ? (
      <div data-testid="BreadcrumbHeader">
        <div className="BreadCrumbHeader_container container d-flex">
          <div
            className={`pb-5 ${headerLevel === `level2` ? `` : `py-md-5`}`}
            style={{ flexGrow: 1 }}
          >
            {showBreadcrumb && (
              <div
                className={`d-md-flex ${
                  headerLevel === `level4` && finalAddress
                    ? `flex-row-reverse`
                    : ``
                }`}
              >
                {headerLevel === `level4` && finalAddress ? (
                  <>
                    <div
                      className="deliveryAddressMobile d-block d-sm-none d-flex px-3 maax-font-weight-regular align-item-center mb-2"
                      style={{
                        marginTop: isRoDumpsterPage ? "0" : "3.5rem",
                      }}
                    >
                      <ReactSVG
                        wrapper="span"
                        className="locationpoint"
                        src={getContentUrl(
                          "/content/dam/wm/icons/white-location-pin-icon-small.svg",
                        )}
                        style={{ height: `24px` }}
                      />
                      <div>{finalAddress}</div>
                      <div className="flex-grow-1 d-md-none" />
                      <a style={{ color: `white` }} href={homeRedirctionUrl}>
                        Edit
                      </a>
                    </div>
                    <div
                      className="deliveryAddress d-none d-sm-block"
                      style={{
                        width: `40%`,
                        paddingTop: `1rem`,
                        textAlign: `right`,
                        marginLeft: `19rem`,
                      }}
                    >
                      <ReactSVG
                        wrapper="span"
                        className="locationpoint pr-1"
                        src={getContentUrl(
                          "/content/dam/wm/icons/green-location-arrow-pin-icon.svg",
                        )}
                      />
                      <Typography variant="body2" component="span">
                        {strings.DELIVER}
                      </Typography>
                      <Typography
                        variant="subtitle1"
                        component="span"
                        style={{
                          textDecoration: `underline`,
                          cursor: `pointer`,
                          fontSize: 14,
                          paddingLeft: 6,
                        }}
                        onClick={() => {
                          setCustomerAddress(finalAddress)
                          ssrWindow.location.href = homeRedirctionUrl
                        }}
                      >
                        {finalAddress}
                      </Typography>
                    </div>
                  </>
                ) : null}
              </div>
            )}
            {headerLevel === `level4` ? (
              <h1>{onlineProducts.selectedProductName}</h1>
            ) : (
              <FormattedTextField
                component="h1"
                className={`BreadcrumbHeader__heading maax-font-weight-black ${
                  !showBreadcrumb ? `small-top-margin` : `large-top-margin`
                } ${
                  !isEmpty(secondaryCTA.text) ? `multiple-cta-header` : ``
                } wm-text-new-green mb-0 ${
                  headerLevel === `level2`
                    ? `alert-spacing mt-0 set-extraspace-level-2`
                    : ``
                }`}
                setRef={this.breadcrumRef}
                style={this.state.style}
                useTypography
              >
                {title}
              </FormattedTextField>
            )}
            {descriptionContent ? (
              <FormattedTextField
                className="BreadcrumbHeader__description maax-font-weight-regular"
                style={{
                  marginTop: `${!isEmpty(secondaryCTA) ? `1.5rem` : ``}`,
                }}
              >
                {descriptionContent}
              </FormattedTextField>
            ) : null}
            {ctaTextContent ? (
              <div
                className={isCtaLinkExits ? `` : `hideCtaBtn`}
                style={{
                  marginTop: `${!isEmpty(secondaryCTA) ? `1.5rem` : 64}`,
                }}
              >
                <ButtonPrimary
                  analytics_key={analytics_key}
                  ariaLabel={ctaTextContent}
                  onClick={() => {
                    if (ctaUrlContent.indexOf(`#`) === 0) {
                      setModalId(ctaUrlContent)
                      return
                    }

                    this.handleNavigation(ctaUrlContent, isExternalLink)
                  }}
                >
                  {ctaTextContent}
                </ButtonPrimary>
              </div>
            ) : null}
            {secondaryDescriptionContent ? (
              <FormattedTextField
                className="BreadcrumbHeader__description maax-font-weight-regular"
                style={{
                  lineHeight: `2.5rem`,
                  marginTop: `${!isEmpty(secondaryCTA) ? `1.5rem` : `6.25rem`}`,
                }}
              >
                {secondaryDescriptionContent}
              </FormattedTextField>
            ) : null}
            {get(secondaryCTA, `path`, ``) && get(secondaryCTA, `text`, ``) ? (
              <div
                className={isCtaLinkExits ? `` : `hideCtaBtn`}
                style={{
                  marginTop: `${!isEmpty(secondaryCTA) ? `1.5rem` : 64}`,
                }}
              >
                <ButtonPrimary
                  analytics_key={get(secondaryCTA, `analytics_key`, ``)}
                  ariaLabel={get(secondaryCTA, `text`, ``)}
                  onClick={() => {
                    this.handleNavigation(
                      get(secondaryCTA, `path`, ``),
                      get(secondaryCTA, `isExternalLink`, false),
                    )
                  }}
                  removeUpperCase
                >
                  {get(secondaryCTA, `text`, ``)}
                </ButtonPrimary>
              </div>
            ) : null}
          </div>
          {headerLevel === `level2` ? (
            <div
              className="BreadcrumbHeader__image-l2"
              style={{ width: `545px`, marginLeft: `2.5rem` }}
            >
              <img
                src={getContentUrl(l2image)}
                width="545"
                height="327"
                alt={l2imageAltText}
              />
            </div>
          ) : null}
        </div>
      </div>
    ) : null
  }
}

BreadcrumbHeader.propTypes = {
  strings: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
  setCustomerAddress: PropTypes.func.isRequired,
  setModalId: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  languageRoute: PropTypes.string.isRequired,
  headerLevel: PropTypes.string.isRequired,
  l1backgroundImage: PropTypes.string,
  l2image: PropTypes.string,
  l2imageAltText: PropTypes.string,
  l2description: PropTypes.string,
  l2ctaText: PropTypes.string,
  l2ctaUrl: PropTypes.string,
  l2secondaryDescription: PropTypes.string,
  l2SecondaryButton: PropTypes.object,
  l3description: PropTypes.string,
  l3ctaText: PropTypes.string,
  l3ctaUrl: PropTypes.string,
  l3secondaryDescription: PropTypes.string,
  l3SecondaryButton: PropTypes.object,
  analytics_key: PropTypes.string,
  isExternalLink: PropTypes.bool,
  showBreadcrumb: PropTypes.bool,
  customerSelections: PropTypes.object,
  level4Items: PropTypes.array,
  onlineProducts: PropTypes.object,
  forceGrayBGForComponent: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
  ]),
}

BreadcrumbHeader.defaultProps = {
  analytics_key: ``,
  showBreadcrumb: true,
  l1backgroundImage: ``,
  l2image: ``,
  l2imageAltText: ``,
  l2description: ``,
  l2ctaText: ``,
  l2ctaUrl: ``,
  l2secondaryDescription: ``,
  l2SecondaryButton: {},
  l3description: ``,
  l3ctaText: ``,
  l3ctaUrl: ``,
  l3secondaryDescription: ``,
  l3SecondaryButton: {},
  isExternalLink: false,
  customerSelections: {},
  level4Items: [],
  onlineProducts: {},
  forceGrayBGForComponent: null, // if not authored this value will be null,
}

export default withRouter(withLocalization(strings)(BreadcrumbHeader))
